import styled from "styled-components";

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  background-color: white;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.dataViz.primaryBlue100};
  gap: 20px;
  grid-column: ${({ fullWidth }) => (fullWidth ? "span 2" : "span 1")};
  max-width: fit-content;
  height: fit-content;
  min-height: 255px;

  ${({ styling }) => styling}
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.dataViz.primaryBlue100};
`;

export const Children = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-around;
  text-align: center;
`;
